<p class="debugMessage"><small>Profile-Me:</small></p>
<mat-toolbar fxLayout="row" class="page-toolbar">

    <!-- Page Title content-->
    <div fxFlex class="toolbar-title">
        <button mat-icon-button class="back" routerLink="">
            <mat-icon>home</mat-icon>
        </button>
        <span class="title">My Profile</span>
    </div>

    <!-- Drop down menu content -->
    <div class="toolbar-menu">
        <button mat-icon-button [matMenuTriggerFor]="dropMenu" fxHide fxShow.xs>
            <mat-icon>more_vert</mat-icon>
        </button>
        <!-- Drop down Menu -->
        <mat-menu #dropMenu="matMenu">
            <!-- Manage -->
            
        </mat-menu>
    </div>

    <!-- Right hand content panel -->
    <div class="toolbar-content" fxHide.xs style="color:lightgrey ;">
        
    </div>

</mat-toolbar>

<!-- <div class="mat-elevation-z8 rounded"> -->
    <router-outlet></router-outlet>
<!-- </div> -->
